import React from 'react';
import { Button, Modal } from 'react-bootstrap';

import EvidencePageViewer from './EvidencePageViewer';

const PageContentModal = ({
  show,
  onHide,
  claimId,
  fileId,
  fileName,
  pageNumber,
}) => (
  <Modal show={show} onHide={onHide} fullscreen>
    <Modal.Header closeButton>
      <Modal.Title className="d-flex flex-column">
        <span>{`Page ${pageNumber}`}</span>
        <small className="text-muted fw-normal" style={{ fontSize: '0.85rem' }}>
          {fileName || 'Unknown file'}
        </small>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body style={{ height: 'calc(100vh - 132px)', padding: '1rem' }}>
      <div style={{ height: '100%', minHeight: 0 }}>
        <EvidencePageViewer
          claimId={claimId}
          fileId={fileId}
          fileName={fileName}
          pageNumber={pageNumber}
        />
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
);

export default PageContentModal;
